import {inject, injectable} from 'inversify';

import type {Nullable} from '../../../../utils/utility-types';
import type {IGetMediaCachedUrlUseCase} from './types';

import {CachedMediaDbService} from '../../../system/cachedMediaDB/CachedMediaDb.service';
import {RemoteFileStorageService} from '../../../system/remoteFileStorage/RemoteFileStorage.service';

@injectable()
export class GetMediaCachedUrlUseCase implements IGetMediaCachedUrlUseCase {
  constructor(
    @inject(RemoteFileStorageService)
    private readonly remoteFileStorageService: RemoteFileStorageService,
    @inject(CachedMediaDbService)
    private readonly dbService: CachedMediaDbService,
  ) {}

  async exec(url: string, ext?: Nullable<string>): Promise<string> {
    const urlId = this.remoteFileStorageService.url.getId(url, ext);
    const cachedUrl = await this.dbService.getCachedUrl(urlId);

    if (!cachedUrl) {
      throw new Error(
        `No cachedUrl for resource key: ${urlId} not found in cached media db!`,
      );
    }

    return cachedUrl;
  }
}
